import { cx } from '@clutch-creator/bridge';

export default (props, vars) =>
  cx(
    !!vars?.['usestatestepopened']?.['state'] && 'opened',
    vars?.['defaultbox145']?.['item']?.['status'] === 'LOCKED' && 'locked'
  );
